import { render, staticRenderFns } from "./ProductosInmobiliaria.vue?vue&type=template&id=1af79f88&scoped=true&"
import script from "./ProductosInmobiliaria.vue?vue&type=script&lang=js&"
export * from "./ProductosInmobiliaria.vue?vue&type=script&lang=js&"
import style0 from "./ProductosInmobiliaria.vue?vue&type=style&index=0&id=1af79f88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af79f88",
  null
  
)

export default component.exports